import React from 'react';

import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import { openBillingPortal } from 'src/common/utils/Organization';

import { ReactComponent as BriefcaseIconBlue } from '../../../common/assets/icons/briefcase_icon_blue.svg';
import { paperStyle } from '../../../common/components/tfa-auth/pages/styles';
import { useAppSelector } from '../../../common/hooks/reduxHooks';
import { useUserRole } from '../../../common/hooks/useUserRole';
import { UserRoles } from '../../../common/types/User';

import PurchasedSubscriptionCell from './PurchasedSubscriptionCell/PurchasedSubscriptionCell';
import SubscriptionPlans from './SubscriptionPlans/SubscriptionPlans';

import './SubscriptionScreen.scss';

const SubscriptionScreen: React.FC = () => {
  const { user } = useAppSelector((state) => state.model);
  const { userRole } = useUserRole();

  const displayRoleInOrganization = () => {
    if (
      userRole === UserRoles.SUPER_ADMIN &&
      user?.accessRoles?.includes(UserRoles.ORG_OWNER)
    ) {
      return `You are a super admin and the owner of ${user?.organization?.name}.`;
    }

    if (userRole === UserRoles.ORG_OWNER)
      return `You are the owner of ${user?.organization?.name}.`;

    if (userRole === UserRoles.CODER)
      return `You are a coder of ${user?.organization?.name}.`;

    return `You are a member of ${user?.organization?.name}.`;
  };
  return (
    <Grid
      container
      justifyContent='center'
      alignContent='center'
      style={{
        marginTop: 60,
        marginBottom: 60,
      }}
    >
      <Paper
        elevation={0}
        style={{
          ...paperStyle,
          backgroundColor: '#fbf9f4',
        }}
      >
        <Grid item xs={12} md={12} xl={12}>
          <Box>
            {!user && (
              <CircularProgress
                color='primary'
                size='64px'
                style={{ display: 'block', margin: '24px auto' }}
              />
            )}
            {user && user.organization && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '40px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <BriefcaseIconBlue style={{ marginRight: '20px' }} />
                  <Typography
                    variant='h6'
                    color='rgba(0, 33, 69, 0.5)'
                    style={{
                      fontWeight: 500,
                      fontSize: '24px',
                    }}
                  >
                    {displayRoleInOrganization()}
                  </Typography>
                </Box>
                {((userRole === UserRoles.SUPER_ADMIN &&
                  user?.accessRoles?.includes(UserRoles.ORG_OWNER)) ||
                  userRole === UserRoles.ORG_OWNER) && (
                  <Button
                    onClick={() => openBillingPortal(user?.email)}
                    disableElevation
                    color='primary'
                    variant='contained'
                    sx={{
                      borderRadius: '50px',
                      height: '50px',
                      mt: '24px',
                    }}
                  >
                    <Typography color='white'>
                      Access Stripe Customer Portal
                    </Typography>
                  </Button>
                )}
              </Box>
            )}
            {user && !user.organization && (
              <>
                <PurchasedSubscriptionCell />
                <Divider
                  orientation='horizontal'
                  sx={{
                    marginTop: '30px',
                    marginBottom: '30px',
                  }}
                />
                <SubscriptionPlans />
              </>
            )}
          </Box>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default SubscriptionScreen;
